// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateCashRegisterMutationVariables = Types.Exact<{
  upsertCashRegisterDTO: Types.UpsertCashRegisterDtoInput;
}>;


export type UpdateCashRegisterMutationResult = { __typename?: 'Mutation', updateCashRegister: boolean };

export const UpdateCashRegisterGql = gql`
    mutation UpdateCashRegister($upsertCashRegisterDTO: UpsertCashRegisterDTOInput!) {
  updateCashRegister(upsertCashRegisterDTO: $upsertCashRegisterDTO)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCashRegisterInjectable extends Apollo.Mutation<UpdateCashRegisterMutationResult, UpdateCashRegisterMutationVariables> {
    override document = UpdateCashRegisterGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */